import { api } from './api';
import type { User } from '../types';

/**
 * Расширенный Auth-сервис. Охватывает все эндпоинты, которые отсутствовали в ApiClient.
 * Дата добавления: 2025-08-04
 */

export interface PasswordChangeRequest {
  current_password: string;
  new_password: string;
}

export interface ResetPasswordRequest {
  email: string;
}

export interface TwoFactorRequest {
  code: string;
}

export interface SocialLoginRequest {
  provider: string;
  access_token: string;
}

export interface AuthUserStats {
  total_users: number;
  active_users: number;
  inactive_users: number;
  new_last_30_days: number;
}

export const authService = {
  /** Обновить профиль текущего пользователя */
  updateProfile(data: Partial<User>): Promise<User> {
    return api.put('/auth/profile', data);
  },

  /** Смена пароля */
  changePassword(payload: PasswordChangeRequest): Promise<{ message: string }> {
    return api.put('/auth/password', payload);
  },

  /** Запрос на сброс пароля */
  resetPassword(payload: ResetPasswordRequest): Promise<{ message: string }> {
    return api.post('/auth/reset-password', payload);
  },

  /** Подтверждение email */
  verifyEmail(token: string): Promise<{ message: string }> {
    return api.post('/auth/verify-email', { token });
  },

  /** Повторная отправка письма подтверждения */
  resendVerification(email: string): Promise<{ message: string }> {
    return api.post('/auth/resend-verification', { email });
  },

  /** Удалить свой аккаунт */
  deleteAccount(): Promise<{ message: string }> {
    return api.delete('/auth/account');
  },

  /** Включить двухфакторную аутентификацию */
  enableTwoFactor(payload: TwoFactorRequest): Promise<{ message: string }> {
    return api.post('/auth/two-factor', payload);
  },

  /** Социальный логин (OAuth) */
  socialLogin(payload: SocialLoginRequest): Promise<{ access_token: string; refresh_token: string }> {
    return api.post('/auth/social', payload);
  },

  /** Статистика пользователей */
  getUserStats(): Promise<AuthUserStats> {
    return api.get('/auth/users/stats');
  },
};

export default authService;
